import { useContext } from "react";
import { InstallationContext } from "../contexts/InstallationContext";

export const useInstallation = () => {
  const context = useContext(InstallationContext);
  if (!context) {
    throw new Error("useInstallation must be used within a InstallationProvider");
  }
  return context;
};
